export default __webpack_public_path__ + "svg/CompaniesLogos/logo_digital-addiction.svg?c4c000b0";